import styled from 'styled-components'
import { useState } from 'react'
import { NegativeIcon } from './NegativeIcon'
import { PositiveIcon } from './PositiveIcon'
import { InfoIcon } from './InfoIcon'
import { WarningIcon } from './WarningIcon'

const colors = {
	negative: '#fdefe8',
	positive: '#f0f7ee',
	warning: '#fff6e6',
	info: '#ebf7f9',
	bulb: '#f0f7ee',
}

const FeedbackBox = styled.div`
	border-radius: 3px;
	background-color: ${({ hollowed, variant }) => (hollowed ? '#ffffff' : colors[variant])};
	display: flex;
	align-items: flex-start;
	padding: 15px;
	line-height: 16px;
`

const IconBox = styled.div`
	margin-right: 15px;
	margin-top: 5px;
	display: flex;
	flex: 0 0 20px;
`
const DismissBox = styled.div`
	margin-right: 15px;
	margin-top: 5px;
	display: flex;
	flex: 0 0 0 20px;
`

const TextBox = styled.div`
	margin-top: 5px;
	display: flex;
	flex: 1 1 auto;
	flex-direction: column;
`

const StyledBulb = styled.span`
	font-size: 18px;
`
export const BulbIcon = () => {
	return (
		<StyledBulb><span role="img" aria-label="hej">💡</span></StyledBulb>
	)
}

const icons = {
	negative: <NegativeIcon />,
	positive: <PositiveIcon />,
	warning: <WarningIcon />,
	info: <InfoIcon />,	
	bulb: <BulbIcon />,
}

export const Feedback = ({ variant = 'negative', children, hollowed, bordered, className, dismissable,  onDismiss}) => {
	// create a fallback if variant is not included in the list
	const [isDismissed, setIsDismissed] = useState(false)
	const handleDismiss = () => {
		setIsDismissed(true)
		if (onDismiss){onDismiss()}
	}
	return (
		<>
			{!isDismissed && (<FeedbackBox variant={variant} className={className} hollowed={hollowed} bordered={bordered}>
				<IconBox>{icons[variant]}</IconBox>
				<TextBox>{children}</TextBox>
				{dismissable && <DismissBox onClick={handleDismiss}>X</DismissBox>}
			</FeedbackBox>)}
		</>
	)
}
